module.exports = __webpack_public_path__ + "static/RizkiRahmadianMDPhD-f1a897566385fee249096e8b0d1f5b71.jpg";